import { createReducer } from '@reduxjs/toolkit';
import { searchActions } from '../elevio.actions/search';
export const initialSearchState = {
    searchStore: {},
    searchInputValue: '',
};
export const searchReducer = createReducer(initialSearchState, (builder) => builder
    .addCase(searchActions.setInitialConversationSearchState, (state, action) => {
    state.searchStore[action.payload.conversationId] = {
        searchTerm: '',
    };
})
    .addCase(searchActions.setSearchTerm, (state, action) => {
    const { conversationId } = action.payload;
    if (state.searchStore[conversationId]) {
        state.searchStore[conversationId].searchTerm = action.payload.term;
    }
    else {
        state.searchStore[conversationId] = {
            searchTerm: action.payload.term,
        };
    }
})
    .addCase(searchActions.setSearchInputValue, (state, action) => {
    state.searchInputValue = action.payload.value;
})
    .addCase(searchActions.initialiseInputValue, (state, action) => {
    state.searchInputValue = action.payload.value;
}));
